/* projects/speaker-platform/src/app/pages/statistic-speaker-validate/statistic-speaker-validate.component.scss */
/*# sourceMappingURL=statistic-speaker-validate.component-BRIY4U37.css.map */
